import React from "react";
import { Paper, Box, Typography } from "@mui/material";
import { ArrowForward } from "@mui/icons-material";
import { textPrimary, textSecondary, softShadow } from "../constants/consts";

export default function AppActionCard({
  icon: Icon,
  title,
  subtitle,
  accentColor,
  onTap,
}) {
  return (
    <Paper
      elevation={0}
      onClick={onTap}
      sx={{
        p: 3,
        height: 220,
        borderRadius: 3,
        cursor: "pointer",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        boxShadow: softShadow,
        border: "1px solid",
        borderColor: "rgba(0,0,0,0.06)",
        transition: "all 0.25s ease",
        position: "relative",
        overflow: "hidden",
        "&:hover": {
          transform: "translateY(-4px)",
          boxShadow: `0 12px 28px ${accentColor}33`,
          borderColor: `${accentColor}55`,
          "& .arrow": { transform: "translateX(4px)", color: accentColor },
        },
        "&::before": {
          content: '""',
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: 4,
          backgroundColor: accentColor,
        },
      }}
    >
      <Box>
        <Box
          sx={{
            width: 56,
            height: 56,
            borderRadius: 2.5,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: `${accentColor}1A`,
            color: accentColor,
            mb: 2,
            mx: "auto",
          }}
        >
          <Icon sx={{ fontSize: 30 }} />
        </Box>
        <Typography
          variant="h6"
          fontWeight={700}
          color={textPrimary}
          gutterBottom
          sx={{ textAlign: "center" }}
        >
          {title}
        </Typography>
        <Typography
          variant="body2"
          color={textSecondary}
          sx={{ lineHeight: 1.5 }}
        >
          {subtitle}
        </Typography>
      </Box>
      <Box
        className="arrow"
        sx={{
          display: "flex",
          alignItems: "center",
          alignSelf: "flex-end",
          gap: 0.5,
          color: textSecondary,
          transition: "all 0.25s ease",
          fontSize: 20,
          fontWeight: 600,
        }}
      >
        <Typography variant="caption" fontWeight={600}>
          Aç
        </Typography>
        <ArrowForward fontSize="small" />
      </Box>
    </Paper>
  );
}
